import { Box, Grid, Paper, Typography } from "@mui/material";
import AttentionIcon from "../../../../components/Vectors/AttentionIcon";

const styles = {
  paperWithGradientBorder: {
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(180deg, rgba(80, 61, 252, 0.3) 0%, rgba(130, 10, 209, 0.3) 100%); border-box",
    borderRadius: "8px",
    border: "8px solid transparent",
  },
};

const RejectedState = () => {
  return (
    <Box
      sx={{
        margin: 1,
      }}
    >
      <Paper variant="outlined" sx={styles.paperWithGradientBorder}>
        <Grid
          container
          alignItems="center"
          padding={"20px 24px"}
          justify="center"
        >
          <Grid item xs={12}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              padding={"32px 0px"}
            >
              <AttentionIcon />
            </Box>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={8}>
            <Typography
              align="center"
              sx={{
                fontWeight: 400,
                fontSize: 14,

                justifyContent: "center",
                color: "#00010C",
              }}
            >
              Atenção! Encontramos inconsistências nessa NF-e. Por favor,
              realizar a simulação usando outra nota.
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default RejectedState;
